import { render, staticRenderFns } from "./DashboardIndex.vue?vue&type=template&id=21ee4242&scoped=true&"
import script from "./DashboardIndex.vue?vue&type=script&lang=js&"
export * from "./DashboardIndex.vue?vue&type=script&lang=js&"
import style0 from "./DashboardIndex.vue?vue&type=style&index=0&id=21ee4242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee4242",
  null
  
)

export default component.exports